import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DisplayLinkStats } from '../../email-stats/email-stats';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { BehaviorSubject } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'email-link-activity-header',
  imports: [
    CommonModule, //
    TranslateModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    GalaxyLoadingSpinnerModule,
  ],
  templateUrl: './link-activity-header.component.html',
  styleUrls: ['./link-activity-header.component.scss'],
})
export class LinkActivityHeaderComponent implements OnChanges {
  @Input() selectedLink: DisplayLinkStats;
  @Input() allLinks: DisplayLinkStats[];

  private readonly loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  readonly loading$ = this.loading$$.asObservable();

  @Output() changeLinkEvent = new EventEmitter<DisplayLinkStats>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.selectedLink) {
      this.loading$$.next(false);
    }
  }

  changeLink(url: string): void {
    if (url !== this.selectedLink.url) {
      this.loading$$.next(true);
      this.changeLinkEvent.emit(this.allLinks.find((nextLink) => nextLink.url === url));
    }
  }
}
